function normalizeMessage(message) {
  return String(message || '').trim();
}

export function translateApiError(t, error, fallback, map = {}) {
  const rawMessage =
    typeof error === 'string'
      ? normalizeMessage(error)
      : normalizeMessage(error?.message || error?.error || '');

  if (!rawMessage) {
    return fallback;
  }

  const mappedKey = map[rawMessage] || map[rawMessage.toLowerCase()];
  if (mappedKey) {
    return t(mappedKey, fallback);
  }

  return rawMessage;
}
